var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgCyan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1080,
    preserveAspectRatio: "none",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(\"#SvgjsMask2351\")",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    x: 0,
    y: 0,
    fill: "url(#SvgjsLinearGradient2352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962 1006.03 a332.16 332.16 0 1 0 664.32 0 a332.16 332.16 0 1 0 -664.32 0z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.565,367.351C462.866,370.063,537.967,340.577,580.221,276.986C627.453,205.904,645.718,114.084,604.516,39.344C562.12,-37.561,474.331,-77.302,386.565,-74.303C303.754,-71.473,230.38,-20.527,192.969,53.406C158.805,120.923,175.654,199.609,215.371,264.017C252.868,324.825,315.17,364.813,386.565,367.351",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.1218495856334 859.3749002152526L889.7719169951333 749.0434717564107 688.4497406021204 696.7340848715818z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.88,404.934C1114.029,408.379,1162.593,402.068,1185.357,365.251C1208.929,327.126,1196.393,278.417,1172.586,240.438C1150.387,205.024,1112.62,180.454,1070.88,182.624C1032.178,184.636,1003.864,215.76,985.977,250.139C969.642,281.537,967.2,318.159,984.22,349.191C1001.923,381.468,1034.184,402.004,1070.88,404.934",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.84 822.76 a256.75 256.75 0 1 0 513.5 0 a256.75 256.75 0 1 0 -513.5 0z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.1472631521422 951.8695197556251L2049.9088258793568 829.0543908886935 1812.3053512153522 730.3196112313377z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.510938437665374 845.6242044345363L65.11003769904757 1069.9846117901823 289.4704450546934 965.3636356534693 184.84946891798052 741.0032282978234z",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564.685,1033.256C1668.665,1039.279,1776.955,993.398,1824.299,900.626C1868.72,813.583,1821.794,715.018,1769.089,632.726C1721.627,558.619,1652.434,501.952,1564.685,495.27C1463.079,487.533,1348.061,508.015,1298.169,596.865C1248.893,684.619,1299.959,787.401,1352.415,873.292C1401.909,954.333,1469.885,1027.765,1564.685,1033.256",
    fill: "rgba(255, 255, 255, 0.1)",
    className: "triangle-float3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SvgjsMask2351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "89.06%",
    y1: "-19.44%",
    x2: "10.94%",
    y2: "119.44%",
    gradientUnits: "userSpaceOnUse",
    id: "SvgjsLinearGradient2352"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 188, 212, 1)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 96, 100, 1)",
    offset: 1
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            @keyframes float1 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(-10px, 0)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float1 {\r\n                animation: float1 5s infinite;\r\n            }\r\n\r\n            @keyframes float2 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(-5px, -5px)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float2 {\r\n                animation: float2 4s infinite;\r\n            }\r\n\r\n            @keyframes float3 {\r\n                0%{transform: translate(0, 0)}\r\n                50%{transform: translate(0, -10px)}\r\n                100%{transform: translate(0, 0)}\r\n            }\r\n\r\n            .triangle-float3 {\r\n                animation: float3 6s infinite;\r\n            }\r\n        "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCyan);
export default __webpack_public_path__ + "static/media/bgCyan.924810c9958622555e01b4d83a92438e.svg";
export { ForwardRef as ReactComponent };